import _ from 'lodash';

const initState = () => ({
  search: '',
  data: [],
  filters: {
    type: 'venue',
    competitionIds: [],
    dateRange: [],
  },
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    reset: (state) => _.assign(state, initState()),
    setFilterType: (state, payload) => state.filters.type = payload,
    setFilterCompetitionIds: (state, payload) => state.filters.competitionIds = payload,
    setFilterDateRange: (state, payload) => state.filters.dateRange = payload,
  },
  actions: {},
  getters: {
    type: (state) => state.filters.type,
    competitionIds: (state) => state.filters.competitionIds,
    dateRange: (state) => state.filters.dateRange,
    filters: (state) => state.filters,
  },
};
